import SecuredCardDepositPage from "./SecuredCardDepositPage";
export default SecuredCardDepositPage;
